import {keycloak} from "../api/keycloak";
let token;

export function setToken(tokenVal) {
    token = tokenVal;
}

export function getToken() {
    return keycloak.token;
}